import { useCallback, useEffect, useState } from 'react';
import { applyMode, Mode } from '@cloudscape-design/global-styles';

const STORAGE_KEY = 'pca-theme';

export const getStoredTheme = () => {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === 'dark' || stored === 'light') return stored;
  } catch {
    /* localStorage unavailable (private mode) — fall through to system */
  }
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};

// Drives three things at once: the `dark` class Tailwind keys off, the
// colour-scheme hint that themes native controls and scrollbars, and
// Cloudscape's own dark mode.
export const applyTheme = (theme) => {
  const root = document.documentElement;
  root.classList.toggle('dark', theme === 'dark');
  root.style.colorScheme = theme;
  applyMode(theme === 'dark' ? Mode.Dark : Mode.Light);
};

export const useTheme = () => {
  const [theme, setTheme] = useState(getStoredTheme);

  useEffect(() => {
    applyTheme(theme);
    try {
      window.localStorage.setItem(STORAGE_KEY, theme);
    } catch {
      /* nothing to persist to — the in-memory theme still applies */
    }
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme((t) => (t === 'dark' ? 'light' : 'dark'));
  }, []);

  return { theme, setTheme, toggleTheme };
};
